import { Module } from 'vuex-smart-module';
import RepairsActions from './actions';
import RepairsGetters from './getters';
import RepairsMutations from './mutations';
import RepairsState from './state';
import RepairsInfo from './modules/repairs-info';
import NewRepair from './modules/new-repair/index';
import RepairsWarranty from './modules/warranty';
import RepairsReturnZips from './modules/return-zips';

export default new Module({
  state: RepairsState,
  mutations: RepairsMutations,
  actions: RepairsActions,
  getters: RepairsGetters,
  modules: {
    repairs_info: RepairsInfo,
    new_repair: NewRepair,
    warranty: RepairsWarranty,
    return_zips: RepairsReturnZips,
  },
});
